module.exports = __webpack_public_path__ + "images/emoji/wolf.f0ec492521232fdf629b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wolf.png
// module id = Jcgy
// module chunks = 14